import React from 'react';

function Loader() {
    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <span className="text-2xl text-gray-600">Cargando...</span>
        </div>
    );
}

export default Loader;
